import { css } from 'aphrodite';
import * as React from 'react';
import { ITemplate } from '../../../../extViewmodels';
import { brandPrimary } from '../../../styles/colors';
import { bs } from '../../../styles/styles';
import { DocumentSearchIcon } from '../../svgs/icons/DocumentSearchIcon';
import { NewsletterTemplateBrowserDialog } from '../NewsletterTemplateBrowserDialog';
import { s } from './styles';

interface Props {
	initialTemplateId?: string;
	onTemplateSelected: (template: ITemplate) => void;
	onCancel?: () => void;
}

export function NewsletterTemplateSelectorButton(props: Props) {
	const [showingMessageSelectorModal, setShowingMessageSelectorModal] = React.useState(!props.initialTemplateId);
	const onMessageSelectorModalRequestClose = (template: ITemplate, cancel?: boolean) => {
		setShowingMessageSelectorModal(false);
		if (!!template && !cancel) {
			props.onTemplateSelected(template);
		} else {
			props.onCancel();
		}
	};
	return (
		<div className={css(s.container)}>
			<button className={css(s.button)} onClick={() => setShowingMessageSelectorModal(true)}>
				<DocumentSearchIcon width={16} height={16} color={brandPrimary} />
				<div className={css(bs.truncateText)}>Select another newsletter template</div>
			</button>
			<NewsletterTemplateBrowserDialog
				modalProps={{
					isOpen: showingMessageSelectorModal,
					onRequestClose: onMessageSelectorModalRequestClose,
					useDefaultHeader: true,
				}}
				title='Select a Newsletter Template'
			/>
		</div>
	);
}
